import React, { useState } from "react";
import { TextField, Button } from "@mui/material";
import { useUpdatePlayerAddressMutation } from "../redux/crmApi";

const CrmAddressTab = ({
  players,
  searchTerm,
  sortBy,
  sortOrder,
  currentPage,
  requestsPerPage,
}) => {
  const [expanded, setExpanded] = useState(null);
  const [addresses, setAddresses] = useState({});
  const [updatePlayerAddress] = useUpdatePlayerAddressMutation();
  const handleSubmitAddress = async (playerId) => {
    if (!addresses[playerId]) {
      alert("Please enter an address");
      return;
    }

    try {
      await updatePlayerAddress({
        player_id: playerId,
        address: addresses[playerId],
      }).unwrap();
      alert(`Address submitted for Player ID: ${playerId}`);
      setAddresses((prev) => ({ ...prev, [playerId]: "" }));
      setExpanded(null);
    } catch (error) {
      console.error("Failed to submit address:", error);
      alert("Failed to submit address.");
    }
  };
  const handleAddressChange = (playerId, value) => {
    setAddresses((prev) => ({ ...prev, [playerId]: value }));
  };
  // Filter and sort players
  const filteredPlayers = players.filter((player) =>
    player.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const sortedPlayers = [...filteredPlayers].sort((a, b) => {
    const valA = a[sortBy];
    const valB = b[sortBy];
    return sortOrder === "asc"
      ? typeof valA === "string"
        ? valA.localeCompare(valB)
        : valA - valB
      : typeof valB === "string"
        ? valB.localeCompare(valA)
        : valB - valA;
  });

  // Pagination
  const indexOfLastPlayer = currentPage * requestsPerPage;
  const indexOfFirstPlayer = indexOfLastPlayer - requestsPerPage;
  const paginatedPlayers = sortedPlayers.slice(
    indexOfFirstPlayer,
    indexOfLastPlayer,
  );

  return (
    <div
      style={{
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          backgroundColor: "#fff",
        }}
      >
        <thead>
          <tr>
            <th
              style={{
                backgroundColor: "#50868f",
                color: "#fff",
                padding: "16px",
                textAlign: "left",
              }}
            >
              Player ID
            </th>
            <th
              style={{
                backgroundColor: "#50868f",
                color: "#fff",
                padding: "16px",
                textAlign: "left",
              }}
            >
              Name
            </th>
            <th
              style={{
                backgroundColor: "#50868f",
                color: "#fff",
                padding: "16px",
                textAlign: "left",
              }}
            >
              Country Code
            </th>
            <th
              style={{
                backgroundColor: "#50868f",
                color: "#fff",
                padding: "16px",
                textAlign: "left",
              }}
            >
              Phone Number
            </th>
            <th
              style={{
                backgroundColor: "#50868f",
                color: "#fff",
                padding: "16px",
                textAlign: "left",
              }}
            >
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {paginatedPlayers.map((player) => (
            <React.Fragment key={player.player_id}>
              {console.log("player", player)}
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "16px", textAlign: "left" }}>
                  {player.player_id}
                </td>
                <td style={{ padding: "16px", textAlign: "left" }}>
                  {player.name}
                </td>
                <td style={{ padding: "16px", textAlign: "left" }}>
                  {player.country_code}
                </td>
                <td style={{ padding: "16px", textAlign: "left" }}>
                  {player.phone}
                </td>
                <td style={{ padding: "16px", textAlign: "left" }}>
                  <button
                    style={{
                      padding: "8px 16px",
                      border: "none",
                      borderRadius: "8px",
                      backgroundColor: "#50868f",
                      color: "#fff",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setExpanded(
                        expanded === player.player_id ? null : player.player_id,
                      )
                    }
                  >
                    {expanded === player.player_id ? "Cancel" : "Add Address"}
                  </button>
                </td>
              </tr>
              {expanded === player.player_id && (
                <tr>
                  <td colSpan="5" style={{ backgroundColor: "#f0f0f0" }}>
                    <div style={{ padding: "20px" }}>
                      <TextField
                        fullWidth
                        label="Enter Address"
                        value={addresses[player.player_id] || ""}
                        onChange={(e) =>
                          handleAddressChange(player.player_id, e.target.value)
                        }
                        sx={{ mb: 2 }}
                        multiline
                        rows={3}
                      />
                      <Button
                        variant="contained"
                        onClick={() => handleSubmitAddress(player.player_id)}
                        sx={{
                          background: "#50868f",
                          "&:hover": { background: "#3a6a73" },
                        }}
                      >
                        Submit Address
                      </Button>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CrmAddressTab;
